import Documents from './container';

export default Documents;
